import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import ViewMoreButton from '@shared/pagination/ViewMoreButton'
import { T } from '@transifex/react'
import useInProgressRecognitions from '../../useInProgressRecognitions'
import DraftAndScheduleCard from './DraftAndScheduleCard'

const DRAFT_CARD_SKELETON_COUNT = 2

const DraftAndScheduleCardSkeleton = () => (
  <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 1 }} />
)

const MobileRecognitionDraftView = () => {
  const {
    fetchMoreRecognitions,
    hasMoreRecognitions,
    isFetchingNextPage,
    isLoading,
    isRefetching,
    recognitionsData,
  } = useInProgressRecognitions()

  if (isLoading || isRefetching) {
    return (
      <Stack spacing={1.5}>
        {Array.from({ length: DRAFT_CARD_SKELETON_COUNT }).map((_, index) => (
          <DraftAndScheduleCardSkeleton key={`draft-skeleton-${index}`} />
        ))}
      </Stack>
    )
  }

  return (
    <Stack spacing={1.5}>
      {recognitionsData.map(recognition => (
        <DraftAndScheduleCard key={recognition.id} recognition={recognition} />
      ))}
      {hasMoreRecognitions && !isFetchingNextPage && (
        <ViewMoreButton
          buttonText={<T _str="View more recognitions" />}
          isFetchingNextPage={isFetchingNextPage}
          fetchMore={fetchMoreRecognitions}
          btnVariant="outlined"
        />
      )}
    </Stack>
  )
}

export default MobileRecognitionDraftView
